function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12.335 22.67a.75.75 0 01-.67 0 10.893 10.893 0 01-.372-.197 22.218 22.218 0 01-3.787-2.658C4.86 17.497 3.25 14.882 3.25 12V4a.75.75 0 01.568-.728l8-2a.75.75 0 01.364 0l8 2A.75.75 0 0120.75 4v8c0 2.883-1.61 5.498-4.256 7.814a22.218 22.218 0 01-4.159 2.857zm.518-2.025a20.737 20.737 0 002.653-1.96C17.86 16.628 19.25 14.368 19.25 12V4.586L12 2.773 4.75 4.586V12c0 2.367 1.39 4.627 3.744 6.686A20.737 20.737 0 0012 21.149c.257-.142.544-.31.853-.504z"
  }));
};

SvgShield.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgShield.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgShield;